import Rating from "../Rating/Rating";
import { FaStar } from "react-icons/fa6";

const ReviewOnCourse = ({ ratings }) => {
  return (
    <div className="flex justify-between font-[Inter] ">
      <div className="space-y-2 text-center">
        <p className="text-8xl">{ratings}</p>
        <Rating ratings={ratings} />
        <p>{ratings} ratings</p>
      </div>
      <div className="space-y-6">
        <div className="flex gap-3 items-center">
          <p>5</p>
          <div className="text-lg text-yellow-400">
            <FaStar />
          </div>
          <div>
            <div className="h-2 sm:h-3 rounded-full w-60 sm:w-[32rem] bg-[#eaebf0]"></div>
          </div>
          <p>0</p>
        </div>
        <div className="flex gap-3 items-center">
          <p>4</p>
          <div className="text-lg text-yellow-400">
            <FaStar />
          </div>
          <div>
            <div className="h-2 sm:h-3 rounded-full w-60 sm:w-[32rem] bg-[#eaebf0]"></div>
          </div>
          <p>0</p>
        </div>
        <div className="flex gap-3 items-center">
          <p>3</p>
          <div className="text-lg text-yellow-400">
            <FaStar />
          </div>
          <div>
            <div className="h-2 sm:h-3 rounded-full w-60 sm:w-[32rem] bg-[#eaebf0]"></div>
          </div>
          <p>0</p>
        </div>
        <div className="flex gap-3 items-center">
          <p>2</p>
          <div className="text-lg text-yellow-400">
            <FaStar />
          </div>
          <div>
            <div className="h-2 sm:h-3 rounded-full w-60 sm:w-[32rem] bg-[#eaebf0]"></div>
          </div>
          <p>0</p>
        </div>
        <div className="flex gap-3 items-center">
          <p>1</p>
          <div className="text-lg text-yellow-400">
            <FaStar />
          </div>
          <div>
            <div className="h-2 sm:h-3 rounded-full w-60 sm:w-[32rem] bg-[#eaebf0]"></div>
          </div>
          <p>0</p>
        </div>
      </div>
    </div>
  );
};

export default ReviewOnCourse;
